import { memo } from 'react';
import Box from '@mui/material/Box';
import absWebService from 'app/services/absWebService';

function ABSSplashScreen() {
  var apprestriction = absWebService.getAppRestrictionCookie();
  var bgcolor = "#192f55";
  var logo = "assets/images/logos/BS-BM-Raster-weiss.svg";
  switch (apprestriction) {
    case "tl":
      bgcolor = "#366893";
      logo = "assets/images/logos/tl_trans_white.svg";
      break;
    case "eo":
      bgcolor = "#006d33";
      logo = "assets/images/logos/eo_trans_white.svg";
      break;
  }

  return (
    <div id="abs-splash-screen" style={{ backgroundColor: bgcolor }}>
      <div className="logo">
        <img width="192" id="abs-logo" src={logo} alt="logo" />
      </div>
      <Box
        id="spinner"
        sx={{
          '& > div': {
            backgroundColor: '#fff',
          },
        }}
      >
        <div className="bounce1" />
        <div className="bounce2" />
        <div className="bounce3" />
      </Box>
    </div>
  );
}

export default memo(ABSSplashScreen);
